import PropTypes from 'prop-types';
import { Navigate, Routes, Route } from 'react-router-dom';
import { UploadDocumentsPage } from 'containers/UploadDocumentsPage';
import { EmployeeRegisterForm } from 'containers/EmployeeRegister';
import { EmployeeRegisterTitlePage } from 'containers/EmployeeRegisterTitlePage';
import { InvoiceSearchPage } from 'containers/InvoiceSearchPage';
import { DocumentsCabinetPage } from 'containers/DocumentsCabinet';
import { HomePage } from 'containers/HomePage';
import { ProtectedRoute } from 'components/ProtectedRoute';
import { AccessDeniedPage } from 'components/AccessDeniedPage';
import { Contacts } from 'containers/Contacts';
import { MyInformation } from 'containers/MyInformation';
import { TurnoverPage } from 'containers/TurnoverPage';
import { APP_MODULES, ROUTES } from 'const';
import { TreasuryPage } from 'containers/TreasuryPage';
import SalaryContainer from 'containers/Salary/SalaryContainer';
import { HRPage } from 'containers/HRPage';
import { AdditionalUsers } from 'containers/AdditionalUsers/AdditionalUsers';
import { TermsOfUseLanding } from 'containers/TermsOfUseLanding';
import {
  REGISTERED_TERMS_TRANSLATIONS,
  TERMS_OF_USE_TRANSLATIONS,
} from 'const/translations/TermsOfUse';
import { Store } from 'containers/Store/Store';
import { CartPage } from 'containers/CartPage/CartPage';
import { PACKAGES_NAMES } from 'const/packages';
import { LandingPage } from 'components/LandingPage';
// import { CarbonFootprintPage } from 'components/CarbonFootprintPage';
import { UnsubscribePage } from 'containers/UnsubscribePage';
import { AUTHORIZED_REDIRECTS } from 'const/RoutesRedirects';
import { Counterparties } from 'components/Counterparties/Counterparties';
import { Counterparty } from 'components/Counterparties/Counterparty';
import { News } from 'containers/News';
import { NewsArticle } from 'containers/NewsArticle';
import { MainPage } from 'containers/Salary/MainPage';
import { EmployeesPage } from 'containers/Salary/EmployeesPage';
import { CompanySettingsScheduleDetail } from 'containers/Salary/CompanySettingsPage/CompanySettingsScheduleDetail';
import { CSManageRewardFamily } from 'containers/Salary/CompanySettingsPage/CSManageRewardFamily';
import { CompanySettingsPage } from 'containers/Salary/CompanySettingsPage';
import { RewardsPage } from 'containers/Salary/RewardsPage';
import { CalendarPage } from 'containers/Salary/CalendarPage';
import { PAY_ROUTES_REDIRECTS } from 'const/RoutesRedirects';

const propTypes = {
  authorizedModules: PropTypes.array,
  isPayEnable: PropTypes.bool,
  isCurrentCompanyActivated: PropTypes.bool,
  isMainUser: PropTypes.bool,
  managedSilae: PropTypes.bool,
  silaeProfile: PropTypes.string,
};

const { TERMS_TEXT, TITLE, BACK_TO_HOMEPAGE } = TERMS_OF_USE_TRANSLATIONS;

const {
  EVP,
  PAY_INVOICE,
  SEARCH_INVOICES,
  READONLY_INVOICE,
  APPROVE_INVOICE,
  DOCUMENTS_CABINET,
  UPLOAD_DOCUMENTS,
  PRE_VALIDATE_INVOICE,
} = APP_MODULES;

const { REGISTERED_USAGE_TERMS, REGISTERED_USAGE_TERMS_TITLE } =
  REGISTERED_TERMS_TRANSLATIONS;

/**
 * Switch children must always be Route or Redirect components
 */
export const AuthorizedRoutes = ({
  authorizedModules = [],
  isPayEnable = false,
  isCurrentCompanyActivated,
  isMainUser,
  managedSilae,
  silaeProfile,
}) => (
  <>
    <Routes>
      <Route path={ROUTES.ROOT} element={<HomePage />} />
      <Route path={ROUTES.CONTACTS} element={<Contacts />} />
      <Route path={ROUTES.MY_INFORMATION} element={<MyInformation />} />
      <Route
        path={ROUTES.TERMS_OF_USE_LANDING}
        element={
          <TermsOfUseLanding
            termsText={TERMS_TEXT}
            hasBreadcrumb
            title={TITLE}
            breadcrumbLink={ROUTES.ROOT}
            breadcrumbText={BACK_TO_HOMEPAGE}
          />
        }
      />

      <Route
        path="*"
        element={
          !isCurrentCompanyActivated ? (
            <Navigate to={ROUTES.ROOT} replace />
          ) : (
            <></>
          )
        }
      />

      <Route
        path={ROUTES.WAIBI_LANDING}
        element={
          <ProtectedRoute
            isAuthorized={isMainUser}
            fallbackRoute={ROUTES.ROOT}
          />
        }
      >
        <Route
          path={ROUTES.WAIBI_LANDING}
          element={<LandingPage pageName={PACKAGES_NAMES.WAIBI} />}
        />
      </Route>

      <Route
        path={ROUTES.SALES_LANDING}
        element={
          <ProtectedRoute
            isAuthorized={isMainUser}
            fallbackRoute={ROUTES.ROOT}
          />
        }
      >
        <Route
          path={ROUTES.SALES_LANDING}
          element={<LandingPage pageName={PACKAGES_NAMES.FACT} />}
        />
      </Route>

      <Route
        path={ROUTES.SAFE_LANDING}
        element={
          <ProtectedRoute
            isAuthorized={isMainUser}
            fallbackRoute={ROUTES.ROOT}
          />
        }
      >
        <Route
          path={ROUTES.SAFE_LANDING}
          element={<LandingPage pageName={PACKAGES_NAMES.SAFE} />}
        />
      </Route>

      <Route
        path={ROUTES.EXPENSES_LANDING}
        element={
          <ProtectedRoute
            isAuthorized={isMainUser}
            fallbackRoute={ROUTES.ROOT}
          />
        }
      >
        <Route
          path={ROUTES.EXPENSES_LANDING}
          element={<LandingPage pageName={PACKAGES_NAMES.PAY} />}
        />
      </Route>
      <Route
        path={ROUTES.HELP}
        element={<LandingPage pageName="HELP" simplified />}
      />

      <Route
        path={ROUTES.MY_EXCO_LANDING}
        element={
          <ProtectedRoute
            isAuthorized={isMainUser}
            fallbackRoute={ROUTES.ROOT}
          />
        }
      >
        <Route
          path={ROUTES.MY_EXCO_LANDING}
          element={<LandingPage pageName={PACKAGES_NAMES.MY_EXCO} />}
        />
      </Route>

      {/* <Route
        path={ROUTES.CARBON_FOOTPRINT}
        element={
          <ProtectedRoute
            isAuthorized={isMainUser}
            fallbackRoute={ROUTES.ROOT}
          />
        }
      >
        <Route
          path={ROUTES.CARBON_FOOTPRINT}
          element={<CarbonFootprintPage pageName="CARBON" />}
        />
      </Route> */}

      <Route path={ROUTES.TURNOVER} element={<TurnoverPage />} />
      <Route path={ROUTES.TREASURY} element={<TreasuryPage />} />
      <Route path={ROUTES.HR} element={<HRPage />} />
      <Route path={ROUTES.DEBTORS} element={<Counterparties />} />
      <Route path={ROUTES.CREDITORS} element={<Counterparties />} />
      <Route path={ROUTES.DEBTOR} element={<Counterparty />} />
      <Route path={ROUTES.CREDITOR} element={<Counterparty />} />

      <Route
        path={ROUTES.EMPLOYEE_REGISTER_TITLE}
        element={
          <ProtectedRoute
            isAuthorized={authorizedModules.includes(EVP) && isPayEnable}
          />
        }
      >
        <Route
          path={ROUTES.EMPLOYEE_REGISTER_TITLE}
          element={<EmployeeRegisterTitlePage />}
        />
      </Route>

      <Route
        path={ROUTES.EMPLOYEE_REGISTER_FORM}
        element={
          <ProtectedRoute
            isAuthorized={authorizedModules.includes(EVP) && isPayEnable}
          />
        }
      >
        <Route
          path={ROUTES.EMPLOYEE_REGISTER_FORM}
          element={<EmployeeRegisterForm />}
        />
      </Route>

      <Route
        path={ROUTES.UPLOAD_DOCUMENTS}
        element={
          <ProtectedRoute
            isAuthorized={authorizedModules.includes(UPLOAD_DOCUMENTS)}
          />
        }
      >
        <Route
          path={ROUTES.UPLOAD_DOCUMENTS}
          element={<UploadDocumentsPage />}
        />
      </Route>

      <Route
        path={`${ROUTES.DOCUMENTS_CABINET}/*`}
        element={
          <ProtectedRoute
            isAuthorized={authorizedModules.includes(DOCUMENTS_CABINET)}
          />
        }
      >
        <Route path="*" element={<DocumentsCabinetPage />} />
      </Route>

      <Route
        path={ROUTES.ADDITIONAL_USERS}
        element={<ProtectedRoute isAuthorized={isMainUser} />}
      >
        <Route path={ROUTES.ADDITIONAL_USERS} element={<AdditionalUsers />} />
      </Route>

      <Route
        path={ROUTES.INVOICE_SEARCH}
        element={
          <ProtectedRoute
            isAuthorized={authorizedModules.includes(SEARCH_INVOICES)}
          />
        }
      >
        <Route path={ROUTES.INVOICE_SEARCH} element={<InvoiceSearchPage />} />
      </Route>

      <Route
        path={ROUTES.EXPENSES}
        element={
          <ProtectedRoute
            isAuthorized={[
              APPROVE_INVOICE,
              PAY_INVOICE,
              READONLY_INVOICE,
              PRE_VALIDATE_INVOICE,
            ].some((module) => authorizedModules.includes(module))}
            fallbackRoute={ROUTES.EXPENSES_LANDING}
          />
        }
      >
        <Route path={ROUTES.EXPENSES} element={<InvoiceSearchPage />} />
      </Route>

      <Route
        path={ROUTES.TERMS_OF_SUBSCRIPTION}
        element={<ProtectedRoute isAuthorized={isMainUser} />}
      >
        <Route
          path={ROUTES.TERMS_OF_SUBSCRIPTION}
          element={
            <TermsOfUseLanding
              hasBreadcrumb={false}
              termsText={REGISTERED_USAGE_TERMS}
              title={REGISTERED_USAGE_TERMS_TITLE}
              hasLogoOnPage
            />
          }
        />
      </Route>

      <Route
        path={ROUTES.STORE}
        element={<ProtectedRoute isAuthorized={isMainUser} />}
      >
        <Route path={ROUTES.STORE} element={<Store />} />
      </Route>

      <Route
        path={ROUTES.CART}
        element={<ProtectedRoute isAuthorized={isMainUser} />}
      >
        <Route path={ROUTES.CART} element={<CartPage />} />
      </Route>

      <Route
        path={ROUTES.UNSUBSCRIBE}
        element={<ProtectedRoute isAuthorized={isMainUser} />}
      >
        <Route path={ROUTES.UNSUBSCRIBE} element={<UnsubscribePage />} />
      </Route>

      <Route path={ROUTES.NEWS} element={<News />} />

      <Route path={`${ROUTES.NEWS}/:id`} element={<NewsArticle />} />

      <Route path={ROUTES.NOT_AUTHORIZED} element={<AccessDeniedPage />} />

      {AUTHORIZED_REDIRECTS.map(({ to, from }) => (
        <Route
          key={`${from}_${to}`}
          path={from}
          element={<Navigate to={to} from={from} />}
        />
      ))}
      {/* {(authorizedModules.includes(EVP) && isPayEnable && (
        <Route path={ROUTES.SALARIES_MAIN_PAGE} element={<SalaryContainer />} />
      )) || <></>} */}
      {/* <Navigate to={ROUTES.ROOT} /> */}

      <Route
        path={ROUTES.SALARIES_MAIN_PAGE}
        element={
          <SalaryContainer>
            <MainPage />
          </SalaryContainer>
        }
      />
      <Route
        path={ROUTES.SALARIES_EMPLOYEES}
        element={
          <SalaryContainer>
            <EmployeesPage />
          </SalaryContainer>
        }
      />
      <Route
        path={ROUTES.SALARIES_COMPANY_SETTINGS_SCHEDULE}
        element={
          <SalaryContainer>
            <CompanySettingsScheduleDetail />
          </SalaryContainer>
        }
      />
      <Route
        path={ROUTES.SALARIES_COMPANY_SETTINGS_REWARD}
        element={
          <SalaryContainer>
            <CSManageRewardFamily />
          </SalaryContainer>
        }
      />
      <Route
        path={ROUTES.SALARIES_COMPANY_SETTINGS}
        element={
          <SalaryContainer>
            <CompanySettingsPage />
          </SalaryContainer>
        }
      />
      {(!managedSilae || (managedSilae && silaeProfile === '1B')) && (
        <>
          <Route
            path={ROUTES.SALARIES_REWARDS}
            element={
              <SalaryContainer>
                <RewardsPage />
              </SalaryContainer>
            }
          />
          <Route
            path={ROUTES.SALARIES_CALENDAR}
            element={
              <SalaryContainer>
                <CalendarPage />
              </SalaryContainer>
            }
          />
        </>
      )}

      {PAY_ROUTES_REDIRECTS.map(({ from, to }) => (
        <Route
          key={`${from}_${to}`}
          path={from}
          element={<Navigate to={to} replace />}
        />
      ))}
    </Routes>

    {/* {authorizedModules.includes(EVP) && isPayEnable && <SalaryContainer />} */}
  </>
);

AuthorizedRoutes.propTypes = propTypes;
